import React, { useState } from 'react';
import { CotizacionData } from '../../types/cotizaciones';

interface CotizacionesListProps {
  cotizaciones: CotizacionData[];
  onSelect: (cotizacion: CotizacionData) => void;
}

export const CotizacionesList: React.FC<CotizacionesListProps> = ({
  cotizaciones,
  onSelect
}) => {
  const [expandedItems, setExpandedItems] = useState<{[key: number]: boolean}>({});

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const toggleExpanded = (index: number) => { // Usado en código comentado (línea 95)
    setExpandedItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };
  if (cotizaciones.length === 0) {
    return (
      <div className="text-center py-8">
        <div className="text-gray-400 mb-4">
          <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
        <p className="text-gray-600 text-lg font-medium">No hay cotizaciones disponibles</p>
        <p className="text-gray-500 text-sm mt-2">Intenta con otros datos o verifica la conexión</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {cotizaciones.map((cotizacion, index) => (
        <div 
          key={`${cotizacion.carrier}-${index}`}
          className={`p-6 rounded-lg border-2 cursor-pointer transition-all hover:shadow-lg ${
            index === 0 
              ? 'border-green-500 bg-green-50 hover:bg-green-100' 
              : 'border-gray-200 bg-white hover:bg-gray-50'
          }`}
          onClick={() => onSelect(cotizacion)}
        >
          <div className="flex justify-between items-center">
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-2">
                <h3 className="font-semibold text-xl text-gray-800">
                  {cotizacion.carrier==='InterRapidisimo'?'Inter Rapidisimo':
                   cotizacion.carrier==='Noventa9Minutos'?'99 Minutos':
                   cotizacion.carrier==='deprisa'?'Deprisa':
                   cotizacion.carrier==='Coordinadora'?'Coordinadora': cotizacion.carrier}
{/*                   {cotizacion.data?.service && (
                    <span className="text-sm font-normal text-gray-500 ml-2">
                      ({cotizacion.data.service='ground'?'Terrestre': cotizacion.data.service='air'?'Aereo': 'Maritimo'})
                    </span>
                  )} */}
                </h3>
                {index === 0 && (
                  <span className="bg-green-500 text-white px-3 py-1 rounded-full text-xs font-bold">
                    MEJOR PRECIO
                  </span>
                )}
              </div>
              
              <div className="grid grid-cols-2 gap-4 text-sm text-gray-600">
                <div>
                  <span className="font-medium">Tiempo de entrega: </span>
                  <span className="font-semibold text-blue-600">
                    {cotizacion.diasEntrega ? `${cotizacion.diasEntrega} días` : 
                     cotizacion.data?.deliveryEstimate ? 
                       cotizacion.data.deliveryEstimate.replace(' days', '').replace(' day', '') + ' días' :
                       'No disponible'}
                  </span>
                </div>
                <div>
                  <span className="font-medium">Servicio: </span>
                  <span className="font-semibold text-green-600">
                    {cotizacion.data?.serviceDescription || 'Estándar'}
                  </span>
                </div>
              </div>
              
              {cotizacion.data?.deliveryDate && (
                <div className="mt-2 text-xs text-gray-500">
                  <span className="font-medium">Fecha estimada:</span> {cotizacion.data.deliveryDate.date}
                </div>
              )}
              
              {/* Botón para ver más detalles */}
              {/*<div className="mt-3">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleExpanded(index);
                  }}
                  className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center gap-1"
                >
                  {expandedItems[index] ? 'Ver menos' : 'Ver más detalles'}
                  <svg 
                    className={`w-4 h-4 transition-transform ${expandedItems[index] ? 'rotate-180' : ''}`}
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
              </div> */}
            </div>
            
            <div className="text-right ml-6">
              <p className="text-2xl font-bold text-custom-blue">
                ${cotizacion.precio.toLocaleString('es-CO')}
              </p>
            </div>
          </div>
          
{/*           {index === 0 && (
            <div className="mt-4 p-3 bg-green-100 rounded-lg">
              <p className="text-green-800 text-sm font-medium">
                💡 Esta es la opción más económica disponible
              </p>
            </div>
          )} */}
          
          {/* Sección expandible con más detalles */}
          {expandedItems[index] && (
            <div className="mt-4 p-4 bg-gray-50 rounded-lg border-t">
              <h4 className="font-semibold text-gray-800 mb-3">Detalles del servicio</h4>
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div>
                  <span className="font-medium text-gray-600">Precio base:</span>
                  <p className="font-semibold">${(cotizacion.data?.basePrice || 0).toLocaleString('es-CO')}</p>
                </div>
                <div>
                  <span className="font-medium text-gray-600">Seguro:</span>
                  <p className="font-semibold">${(cotizacion.data?.insurance || 0).toLocaleString('es-CO')}</p>
                </div>
                <div>
                  <span className="font-medium text-gray-600">Servicios adicionales:</span>
                  <p className="font-semibold">${(cotizacion.data?.additionalServices || 0).toLocaleString('es-CO')}</p>
                </div>
                <div>
                  <span className="font-medium text-gray-600">Cargos adicionales:</span>
                  <p className="font-semibold">${(cotizacion.data?.additionalCharges || 0).toLocaleString('es-CO')}</p>
                </div>
                {cotizacion.data?.packageDetails && (
                  <div className="col-span-2">
                    <span className="font-medium text-gray-600">Detalles del paquete:</span>
                    <p className="font-semibold">
                      Peso: {cotizacion.data.packageDetails.totalWeight} {cotizacion.data.packageDetails.weightUnit}
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
